import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';
import { zBatchLoader } from 'utils/ui-helpers/stackingContexts';

const useStyles = createUseStyles((theme: ITheme) => ({
  '@keyframes rotate-loader': {
    '0%': {
      transform: 'rotateZ(0deg)',
    },
    '100%': {
      transform: 'rotateZ(-360deg)',
    },
  },
  '@keyframes loader-success': {
    '0%': {
      strokeDashoffset: '-176%',
    },
    '100%': {
      strokeDashoffset: '-44%',
    },
  },
  '@keyframes loader-error': {
    '0%': {
      strokeDasharray: 'var(--stroke-dasharray-loading)',
      strokeDashoffset: '-176%',
    },
    '35%': {
      strokeDasharray: 'var(--stroke-dasharray-loading)',
    },
    '100%': {
      strokeDasharray: 'var(--stroke-dasharray-error)',
      strokeDashoffset: '-1',
    },
  },
  '@keyframes fade': {
    to: {
      opacity: 0,
    },
  },

  progressLoadingWrap: {
    '--box-bg-color': '#eef3fe',
    '--box-circle-bg-color': '#4a7ef2',
    '--box-inner-gutter': '13px',
    '--stroke-dasharray-loading': '40% 0% 40% 1000%',
    '--stroke-dasharray-error': '55% 48% 55% 1000%',
    '--inner-gutter': '24px',
    '--progress-transition': '.3s ease',
    position: 'absolute',
    top: theme.spacings.s0,
    right: theme.spacings.s0,
    bottom: theme.spacings.s0,
    left: theme.spacings.s0,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: 'var(--inner-gutter)',
    backgroundColor: props => props?.isDarkMode ? '#00000080' : '#ffffff80',
    opacity: 0,
    transition: 'all var(--progress-transition)',
    zIndex: zBatchLoader,
    pointerEvents: 'none',
  },
  progressLoadingBox: {
    position: 'relative',
    display: 'flex',
    width: 64,
    height: 64,
    padding: 'var(--box-inner-gutter)',
    backgroundColor: 'var(--box-bg-color)',
    borderRadius: theme.radiuses.circle,
    transition: 'all var(--progress-transition)',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 'calc(100% - (calc(2 * var(--box-inner-gutter))))',
      height: 'calc(100% - (calc(2 * var(--box-inner-gutter))))',
      backgroundColor: 'var(--box-circle-bg-color )',
      borderRadius: theme.radiuses.circle,
      transition: 'background-color var(--progress-transition)',
    },
  },
  onProgressState: {
    opacity: 1,
  },
  onSuccessState: {
    '--box-bg-color': '#def8f2',
    opacity: 1,
    animation: '0.5s $fade 2s ease-out 1 forwards',
  },
  onErrorState: {
    '--box-bg-color': '#fde3e2',
    opacity: 1,
  },
  loader: {
    width: '84%',
    height: '84%',
    margin: 'auto',
    transform: 'rotateZ(0deg)',
  },
  loaderProgress: {
    animation: '$rotate-loader 0.8s linear infinite',
  },
  loaderSuccess: {
    '--box-circle-bg-color': '#4cdbb9',
    '& $loaderPath': {
      animation: '$loader-success 0.5s ease-out 1 forwards',
    },
  },
  loaderError: {
    '--box-circle-bg-color': '#f46b66',
    '& $loaderPath': {
      animation: '$loader-error 0.6s ease-out 1 forwards',
    },
  },
  loaderPath: {
    fill: 'transparent',
    stroke: 'white',
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeDasharray: 'var(--stroke-dasharray-loading)',
    strokeDashoffset: '-176%',
  },
  retryButtonWrap: {
    position: 'absolute',
    right: 'var(--inner-gutter)',
    bottom: 'var(--inner-gutter)',
    left: 'var(--inner-gutter)',
    display: 'flex',
    justifyContent: 'center',
    maxWidth: 'calc(100% - (var(--inner-gutter) * 2))',
    '& $retryButtonIcon': {
      margin: theme.spacings.s0,
      width: 20,
    },
  },
  retryButton: {
    display: 'grid',
    gridAutoFlow: 'column',
    gap: 10,
    color: '#7b8196',
    borderColor: '#ffffff',
    fontSize: '16px',
    transition: 'all var(--progress-transition)',
    '&:hover': {
      background: '#ffffff',
      color: '#282b36',
      borderColor: '#ffffff',
    },
  },
  retryButtonIcon: {
    '& path': {
      transition: 'fill var(--progress-transition)',
      fill: 'currentColor',
    },
  },
}));

export default useStyles;
